import {
  LOAD_NEWS,
  LOAD_NEWS_COMPLETE,
  LOAD_DETAIL_NEW_COMPLETE,
  LOAD_MORE_NEWS,
  LIKE_NEWS,
  FAVORITE_NEWS,
  ADVICE_MORE_NEWS,
  LOAD_NEWS_STICKY_COMPLETE,
  LOAD_NEWS_HIGHLIGHT_COMPLETE,
  LOAD_COMMENTS_COMPLETE,
  INSERT_COMMENT,
  REPLY_COMMENT,
  DELETE_COMMENT,
  LOAD_ALL_REPLIES_COMMENT,
  CHANGE_PAGE_COMMENTS,
  UNLIKE_NEWS,
  UNFAVORITE_NEWS
} from '../constants/actionTypes';

export const initialState = {
  news: [],
  newsById: [],
  newsFavorite: [],
  newsSticky: [],
  newsHighlight: [],
  newsLike: [],
  newsSend: [],
  selectNew: null,
  loaded: false,
  comments: {
    page: 0,
    size: 10,
    content: []
  },
  page: 0,
  total: 0,
  size: 0,
  more: false
};

export default (state = initialState, action) => {
  const {
    type,
    news,
    total,
    page,
    size,
    detail,
    id,
    comments,
    comment
  } = action;

  switch (type) {
    case LOAD_NEWS:
      return { ...state, news: [], loaded: true, more: false };

    case LOAD_NEWS_COMPLETE: {
      return {
        ...state,
        news: state.news.concat(news),
        total,
        page,
        size,
        loaded: false
      };
    }

    case LOAD_NEWS_HIGHLIGHT_COMPLETE: {
      return {
        ...state,
        newsHighlight: state.newsHighlight.concat(news)
      };
    }

    case LOAD_MORE_NEWS: {
      return { ...state, page: state.page + 1 };
    }

    case LOAD_DETAIL_NEW_COMPLETE: {
      return {
        ...state,
        newsById: { ...state.newsById, [id]: detail },
        selectNew: id
      };
    }

    case LOAD_NEWS_STICKY_COMPLETE: {
      return {
        ...state,
        newsSticky: news
      };
    }

    case LIKE_NEWS: {
      return {
        ...state,
        newsLike: state.newsLike.includes(id)
          ? state.newsLike
          : [...state.newsLike, id]
      };
    }

    case UNLIKE_NEWS: {
      return {
        ...state,
        newsLike: state.newsLike.filter(i => i !== id)
      };
    }

    case FAVORITE_NEWS: {
      return {
        ...state,
        newsFavorite: state.newsFavorite.includes(id)
          ? state.newsFavorite
          : [...state.newsFavorite, id]
      };
    }

    case UNFAVORITE_NEWS: {
      return {
        ...state,
        newsFavorite: state.newsFavorite.filter(i => i !== id)
      };
    }

    case ADVICE_MORE_NEWS: {
      return {
        ...state,
        more: true
      };
    }

    case LOAD_COMMENTS_COMPLETE: {
      return {
        ...state,
        comments: {
          page,
          content: comments,
          size,
          total
        }
      };
    }

    case INSERT_COMMENT: {
      return {
        ...state,
        comments: {
          ...state.comments,
          page: 0,
          total: state.comments.total + 1,
          content: [comment, ...state.comments.content]
        }
      };
    }

    case REPLY_COMMENT: {
      return {
        ...state,
        comments: {
          ...state.comments,
          content: state.comments.content.map(item =>
            item.id === comment.parentId
              ? {
                  ...item,
                  numReplies: item.numReplies + 1,
                  replies: [comment, ...item.replies]
                }
              : item
          )
        }
      };
    }

    // El id puede ser de un comentario principal o de una respuesta
    case DELETE_COMMENT: {
      const isComment = state.comments.content.some(item => item.id === id);
      return {
        ...state,
        comments: {
          ...state.comments,
          total: isComment ? state.comments.total - 1 : state.comments.total,
          content: state.comments.content
            .filter(item => item.id !== id)
            .map(item => {
              const replies = (item.replies || []).filter(
                reply => (reply.replyId || reply.id) !== id
              );
              return replies.length === (item.replies || []).length
                ? item
                : {
                    ...item,
                    numReplies: item.numReplies - 1,
                    replies
                  };
            })
        }
      };
    }

    case LOAD_ALL_REPLIES_COMMENT: {
      return {
        ...state,
        comments: {
          ...state.comments,
          content: state.comments.content.map(item => {
            if (item.id === id) {
              return {
                ...item,
                replies: comments
              };
            }
            return item;
          })
        }
      };
    }

    case CHANGE_PAGE_COMMENTS: {
      return {
        ...state,
        comments: {
          page,
          content: state.comments.content.concat(comments),
          size,
          total
        }
      };
    }

    default:
      return state;
  }
};
